import { Reveal } from '@/components/motion';
import { SERVICE_AREAS, CONTACT } from '@/data/site';
import { MapPin, ArrowRight, PhoneCall } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function ServiceAreas() {
  return (
    <>
      <section className="pt-16 md:pt-24 pb-14" data-testid="areas-hero">
        <div className="container-x max-w-4xl">
          <Reveal>
            <div className="overline mb-6">Service areas</div>
            <h1 className="h-display text-balance">{SERVICE_AREAS.headline}</h1>
            <p className="body-lg mt-8 max-w-2xl text-pretty">
              Inclusive Mobility Group operates nationally, with primary hubs in Victoria and Western Australia and active
              service across all Australian states and territories. If your suburb isn't listed below —
              call us. We probably cover it.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24" data-testid="areas-grid">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {SERVICE_AREAS.regions.map((r, i) => (
            <Reveal key={r.state} delay={i * 0.05}>
              <div className="p-8 rounded-3xl bg-neutral-50 border border-neutral-200 hover:border-brand transition h-full">
                <div className="flex items-center gap-2 text-brand mb-4">
                  <MapPin size={20} weight="duotone" />
                  <span className="badge-brand !bg-transparent !text-brand !px-0">{r.state}</span>
                </div>
                <ul className="space-y-2">
                  {r.hubs.map(h => (
                    <li key={h} className="text-ink font-medium">{h}</li>
                  ))}
                </ul>
                <div className="pt-6 mt-6 border-t border-neutral-200">
                  <Link to="/quote" className="text-brand font-semibold text-sm inline-flex items-center gap-1.5">
                    Confirm coverage <ArrowRight size={14} weight="bold" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24">
        <div className="container-x">
          <Reveal>
            <div className="rounded-3xl bg-ink text-white p-10 md:p-16 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-8">
                <div className="overline text-brand-soft mb-4">Not sure?</div>
                <h2 className="h-section text-white text-balance">Call us — chances are we can service your route today.</h2>
                <p className="body-md mt-4 text-white/70">Our national dispatch team can confirm coverage for any suburb in Australia in under two minutes.</p>
              </div>
              <div className="lg:col-span-4 flex flex-col gap-3">
                <a href={`tel:${CONTACT.phone_dial}`} className="btn-primary"><PhoneCall size={16} weight="bold" /> {CONTACT.phone_display}</a>
                <Link to="/contact" className="btn-secondary text-ink">Send us a message</Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
